/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type servicesHostSpacePublic_services$ref: FragmentReference;
declare export opaque type servicesHostSpacePublic_services$fragmentType: servicesHostSpacePublic_services$ref;
export type servicesHostSpacePublic_services = $ReadOnlyArray<{|
  +title: ?string,
  +icon: ?string,
  +description: ?string,
  +free: ?boolean,
  +price: ?{|
    +unit: ?string,
    +excl_tax: ?number,
  |},
  +score: ?number,
  +$refType: servicesHostSpacePublic_services$ref,
|}>;
export type servicesHostSpacePublic_services$data = servicesHostSpacePublic_services;
export type servicesHostSpacePublic_services$key = $ReadOnlyArray<{
  +$data?: servicesHostSpacePublic_services$data,
  +$fragmentRefs: servicesHostSpacePublic_services$ref,
  ...
}>;
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "servicesHostSpacePublic_services",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "free",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SpaceHostServicePrice",
      "kind": "LinkedField",
      "name": "price",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unit",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "excl_tax",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "score",
      "storageKey": null
    }
  ],
  "type": "SpaceHostServices",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '095a72a83715b3cac9f91bf8306c85db';

module.exports = node;
